import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const INDENT_LEN = 15;

const TitleTypography = withStyles({
  root: {
    fontSize: 20,
    paddingTop: 20,
    paddingBottom: 40,
    display: "flex",
    justifyContent: "center"
  }
})(Typography);
const FirstSubtitleTypography = withStyles({
  root: {
    fontSize: 14
  }
})(Typography);
const SecondSubTitleTypography = withStyles({
  root: {
    fontSize: 14,
    paddingLeft: INDENT_LEN
  }
})(Typography);
const FirstContentTypography = withStyles({
  root: {
    fontSize: 14,
    paddingLeft: INDENT_LEN * 2
  }
})(Typography);
const SecondContentTypography = withStyles({
  root: {
    fontSize: 14,
    paddingLeft: INDENT_LEN * 3
  }
})(Typography);
const ThirdContentTypography = withStyles({
  root: {
    fontSize: 14,
    paddingLeft: INDENT_LEN * 4
  }
})(Typography);

TextToHTML.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired
};

TextToHTML.defaultProps = {
  title: null
};

function TextToHTML(props) {
  const { title, text } = props;

  const getArrFromText = input => {
    const LINE_SEPARATOR = "|||";
    const separatedTxt = input.replace(/\n/g, LINE_SEPARATOR);
    const rawArr = separatedTxt.split("|||");

    for (let i = 0; i < rawArr.length; i++) {
      if (rawArr[0].trim().length === 0) {
        rawArr.shift();
      } else {
        break;
      }
    }

    for (let i = 0; i < rawArr.length; i++) {
      if (rawArr[rawArr.length - 1].trim().length === 0) {
        rawArr.pop();
      } else {
        break;
      }
    }

    return rawArr;
  };

  const getHTMLFromArr = input => {
    const htmlArr = [];

    for (let i = 0; i < input.length; i++) {
      const element = input[i];

      const spaceLength = element.length - element.trimStart().length;

      if (spaceLength % 2 !== 0) {
        console.error("wrong indent", element);
      }

      if (element.trimStart().length === 0) {
        htmlArr.push(
          <FirstSubtitleTypography key={i}>
            <br />
          </FirstSubtitleTypography>
        );
      } else if (spaceLength === 0) {
        htmlArr.push(
          <FirstSubtitleTypography key={i}>{element}</FirstSubtitleTypography>
        );
      } else if (spaceLength <= 2) {
        htmlArr.push(
          <SecondSubTitleTypography key={i}>{element}</SecondSubTitleTypography>
        );
      } else if (spaceLength <= 4) {
        htmlArr.push(
          <FirstContentTypography key={i}>{element}</FirstContentTypography>
        );
      } else if (spaceLength <= 6) {
        htmlArr.push(
          <SecondContentTypography key={i}>{element}</SecondContentTypography>
        );
      } else if (spaceLength > 6) {
        htmlArr.push(
          <ThirdContentTypography key={i}>{element}</ThirdContentTypography>
        );
      }
    }

    return htmlArr;
  };

  const getResultText = input => {
    return getHTMLFromArr(getArrFromText(input));
  };

  return (
    <div>
      <TitleTypography>{title}</TitleTypography>
      {getResultText(text)}
    </div>
  );
}

export default TextToHTML;
